import { VipClubDialog } from '@bz/vip-club';

export const route: RouteDefinition = {
  preload: () => {},
  info: {
    login: true,
    dialog: {
      get title() {
        return t('Milestone Cash');
      },
      class: 'w-[500px] h-[700px]',
      // 提高遮罩层 z-index
      // portalClass: '!z-[12000]',
    },
  },
};

export default VipClubDialog;
